import Vue from 'vue'
import Vuex from 'vuex'
import basic from './model/zone'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    toolMenus: [
      {
        text: '首页',
        src: require('./assets/images/home/sy.png'),
        activeSrc: require('./assets/images/home/sy-k.png'),
        isActive: true,
        name: 'index'
      },
      {
        text: '场景模式',
        src: require('./assets/images/home/cj.png'),
        activeSrc: require('./assets/images/home/cj-k.png'),
        isActive: false,
        name: 'scene'
      },
      {
        text: '设备控制',
        src: require('./assets/images/home/sb.png'),
        activeSrc: require('./assets/images/home/sb-k.png'),
        isActive: false,
        name: 'device'
      }
      // {
      //   text: '自动化',
      //   src: require('./assets/images/home/sb.png'),
      //   activeSrc: require('./assets/images/home/sb-k.png'),
      //   isActive: false,
      //   name: 'rule'
      // }
    ],
    deviceMenus: [
      {
        text: '常用设备',
        src: require('./assets/images/device/cysb.png'),
        activeSrc: require('./assets/images/device/cysb-k.png'),
        isActive: true,
        name: 'device'
      },
      {
        text: '群组控制',
        src: require('./assets/images/group/un-group-control.png'),
        activeSrc: require('./assets/images/group/group-control.png'),
        isActive: true,
        name: 'devicegroup'
      },
      {
        text: '门锁',
        src: require('./assets/images/device/door.png'),
        activeSrc: require('./assets/images/device/door-k.png'),
        isActive: false,
        name: 'door_lock'
      },
      {
        text: '照明',
        src: require('./assets/images/device/zm.png'),
        activeSrc: require('./assets/images/device/zm-k.png'),
        isActive: false,
        name: 'light'
      },
      {
        text: '空调',
        src: require('./assets/images/device/kt.png'),
        activeSrc: require('./assets/images/device/kt-k.png'),
        isActive: false,
        name: 'aircon'
      },
      {
        text: '窗帘',
        src: require('./assets/images/device/cl.png'),
        activeSrc: require('./assets/images/device/cl-k.png'),
        isActive: false,
        name: 'curtain'
      },
      {
        text: '新风',
        src: require('./assets/images/device/xf.png'),
        activeSrc: require('./assets/images/device/xf-k.png'),
        isActive: false,
        name: 'airpure'
      },
      {
        text: '风扇',
        src: require('./assets/images/device/fs.png'),
        activeSrc: require('./assets/images/device/fs-k.png'),
        isActive: false,
        name: 'fan'
      },
      {
        text: '智能插座',
        src: require('./assets/images/device/zncz.png'),
        activeSrc: require('./assets/images/device/zncz-k.png'),
        isActive: false,
        name: 'switch'
      },
      {
        text: '智慧空开',
        src: require('./assets/images/device/switch/air_switch_off.png'),
        activeSrc: require('./assets/images/device/switch/air_switc.png'),
        isActive: true,
        name: 'airswitch'
      },
      // {
      //   text: '加湿器',
      //   src: require('./assets/images/device/jsq.png'),
      //   activeSrc: require('./assets/images/device/jsq-k.png'),
      //   isActive: false,
      //   name: 'humidifier'
      // },
      {
        text: '监控',
        src: require('./assets/images/device/jk-g.png'),
        activeSrc: require('./assets/images/device/jk-k.png'),
        isActive: false,
        name: 'video'
      },
      {
        text: '大屏',
        src: require('./assets/images/device/door.png'),
        activeSrc: require('./assets/images/device/door-k.png'),
        isActive: false,
        name: 'screen'
      },
      {
        text: '空调',
        src: require('./assets/images/device/kt.png'),
        activeSrc: require('./assets/images/device/kt-k.png'),
        isActive: false,
        name: 'lora_aircon'
      },
      {
        text: '照明',
        src: require('./assets/images/device/zm.png'),
        activeSrc: require('./assets/images/device/zm-k.png'),
        isActive: false,
        name: 'light_class'
      }
    ],
    zone: null,
    scenes: [],
    devices: [],
    lights: [],
    remotes: [], // 控制面板
    lightsOrign: [],
    extDevices: [],
    otherExtDevices: [],
    // 其他设备外部设备信息
    otherToekn: {},
    extDevicesOrign: [],
    subject: {},
    notify: [],
    sensor: {
      DHTt: 0,
      DHTh: 0,
      ALS: 0,
      PM25: 0,
      PM10: 0,
      CH2O: 0,
      CO2: 0,
      TVOC: 0
    },
    weather: {},
    // 区域配置信息  收藏 、场景
    collection: { scenes: [], devices: [] },
    config: null,
    repair: null,
    sensorTime: null,
    linkage: {
      id: '',
      rule: [
        {
          state: 0,
          type: 'DHTt',
          icon: 'cold.png',
          name: '夏天温度',
          description: '暂未配置，请点击进入，配置后使用',
          action: [{ type: 'aircon', state: 0, tt: 24, mode: 0 }],
          condition: {
            max: 28,
            min: 20
          },
          scene: '',
          viewRange: {
            max: 30,
            min: 16
          },
          isSave: false
        },
        {
          state: 0,
          type: 'DHTt',
          icon: 'heat.png',
          name: '冬天温度',
          description: '暂未配置，请点击进入，配置后使用',
          action: [{ type: 'aircon', state: 0, tt: 24, mode: 1 }],
          condition: {
            max: 10,
            min: 26
          },
          scene: '',
          viewRange: {
            max: 30,
            min: 16
          },
          isSave: false
        },
        {
          state: 0,
          type: 'ALS',
          icon: 'light-sensitive.png',
          name: '光感',
          description: '暂未配置，请点击进入，配置后使用',
          action: [{ type: 'curtain', state: 2 }],
          condition: {
            max: 80,
            min: 50
          },
          scene: '',
          viewRange: {
            max: 22711,
            min: 0
          },
          isSave: false
        },
        {
          state: 0,
          type: 'PM25',
          icon: 'PM2.5.png',
          name: 'PM2.5',
          description: '暂未配置，请点击进入，配置后使用',
          action: [{ type: 'airpure', state: 0, air: 1 }],
          condition: {
            max: 200,
            min: 180
          },
          scene: '',
          viewRange: {
            max: 6000,
            min: 0
          },
          isSave: false
        },
        {
          state: 0,
          type: 'PM10',
          icon: 'PM10.png',
          name: 'PM10',
          description: '暂未配置，请点击进入，配置后使用',
          action: [{ type: 'airpure', state: 0, air: 1 }],
          condition: {
            max: 150,
            min: 130
          },
          scene: '',
          viewRange: {
            max: 6000,
            min: 0
          },
          isSave: false
        },
        {
          state: 0,
          type: 'CO2',
          icon: 'co2.png',
          name: '二氧化碳',
          description: '暂未配置，请点击进入，配置后使用',
          action: [{ type: 'airpure', state: 0, air: 1 }],
          condition: {
            max: 1000,
            min: 900
          },
          scene: '',
          viewRange: {
            max: 6000,
            min: 0
          },
          isSave: false
        },
        {
          state: 0,
          type: 'CH2O',
          icon: 'formaldehyde.png',
          name: '甲醛',
          description: '暂未配置，请点击进入，配置后使用',
          action: [{ type: 'airpure', state: 0, air: 1 }],
          condition: {
            max: 80,
            min: 70
          },
          scene: '',
          viewRange: {
            max: 6000,
            min: 0
          },
          isSave: false
        },
        {
          state: 0,
          type: 'TVOC',
          icon: 'TVOC.png',
          name: 'TVOC',
          description: '暂未配置，请点击进入，配置后使用',
          action: [{ type: 'airpure', state: 0, air: 1 }],
          condition: {
            max: 500,
            min: 400
          },
          scene: '',
          viewRange: {
            max: 6000,
            min: 0
          },
          isSave: false
        },
        {
          state: 0,
          type: 'DHTh',
          icon: 'humidity.png',
          name: '湿度',
          description: '暂未配置，请点击进入，配置后使用',
          action: [{ type: 'switch', state: 0 }],
          condition: {
            max: 50,
            min: 80
          },
          scene: '',
          viewRange: {
            max: 100,
            min: 0
          },
          isSave: false
        },
        {
          state: 0,
          type: 'PIR',
          icon: 'humantouch.png',
          name: '人感',
          description: '暂未配置，请点击进入，配置后使用',
          action: [{ type: 'light', state: 0 }],
          condition: {
            max: ''
          },
          scene: '',
          isSave: false,
          delayTime: 0, // 延迟时间
          timeLimit: {
            // 不生效时间
            start: '',
            end: ''
          }
        }
      ] // 智能联动
    },
    extDevicesNdOrign: [],
    coreIds: [],
    // 分组
    groups: [],
    // 新版节点
    sensorNd: []
  },
  mutations: {
    SET_SENSORND (state, payload) {
      state.sensorNd = payload
    },
    // 电量
    SET_DL (state, payload) {
      // 解析
      // [0,226,0,0,0,0,0,0,0,240,0,0,0,0,0,0,0,0]
      // { nd: 180,state: 0,dt: 150}
      let data = JSON.parse(payload.data)
      let states = 0
      if (data.reg !== 1) {
        states = data.dt[8] * 256 + data.dt[9] === 240 ? 1 : 0
      } else {
        states = data.dt[0] === 255 ? 1 : 0
      }
      console.log(data)
      let current = state.dl.find((item) => item.sid === data.addr)
      if (current) {
        state.dl.forEach((item, index) => {
          if (item.sid === data.addr) {
            state.dl[index].state = states
          }
        })
      } else {
        state.dl.push({
          state: states,
          sid: data.addr,
          nd: data.nd
        })
      }
    },
    /* 菜单的处理 */
    CHANGE_ACTIVE_TOOLMENUS (state, payload) {
      state.toolMenus.forEach((menu, i) => {
        if (i === payload || payload === menu.name) {
          menu.isActive = true
        } else {
          menu.isActive = false
        }
      })
    },
    SET_COREIDS (state, payload) {
      state.coreIds = payload
    },
    CHANGE_ACTIVE_DEVICEMENUS (state, payload) {
      state.deviceMenus.forEach((menu, i) => {
        if (i === payload || payload === menu.name) {
          menu.isActive = true
        } else {
          menu.isActive = false
        }
      })
    },
    // remotes
    SET_REMOTES (state, params) {
      state.remotes = params
    },
    /* 智联联动 */
    SET_LINKAGE (state, payload) {
      state.linkage = payload
    },
    /* 基础数据的初始化 */
    SET_DEVICEMENUS (state, payload) {
      state.deviceMenus = state.deviceMenus.filter((m) =>
        payload.includes(m.name)
      )
    },
    SET_ZONE (state, payload) {
      state.zone = payload
    },
    SET_SCENE (state, payload) {
      payload.forEach((p) => {
        p.active = false
      })
      state.scenes = payload
    },
    SET_DEVICE (state, payload) {
      state.devices = payload
    },
    SET_LIGHT (state, payload) {
      state.lights = payload
    },
    SET_LIGHTS (state, payload) {
      state.lightsOrign = payload
    },
    SET_EXT (state, payload) {
      state.extDevices = payload
    },
    SET_OTHEREXT (state, payload) {
      state.otherExtDevices = JSON.parse(JSON.stringify(payload))
    },
    SET_OTHERTOKEN (state, payload) {
      state.otherToekn = payload
    },
    SET_EXTS (state, payload) {
      state.extDevicesOrign = payload
    },
    SET_EXTSND (state, payload) {
      state.extDevicesNdOrign = payload
    },
    SET_SUBJECT (state, payload) {
      state.subject = payload
    },
    SET_NOTIFY (state, payload) {
      state.notify = payload
    },
    SET_WEATHER (state, payload) {
      state.weather = payload
    },
    SET_COLLECTION (state, payload) {
      Object.assign(state.collection, payload)
    },
    SET_CONFIG (state, payload) {
      state.config = payload
    },
    SET_REPAIR (state, payload) {
      state.repair = payload
    },
    SET_GROUPS (state, payload) {
      state.groups = payload
    },
    /* 基础数据的更新 */
    UPDATE_SUBJECT (state, payload) {
      state.subject[payload.week] = payload.data
    },
    UPDATE_SENSOR (state, payload) {
      // 环境最近更新的时间
      state.sensorTime = payload.lastHeard
      if (typeof payload === 'object') {
        if (state.repair) {
          // 如果是存在修复规则
          // const SPECIAL = { PM25: 100, PM10: 120, CH2O: 70, TVOC: 400, CO2: 2000 }
          for (const key in payload) {
            if (!state.sensor.hasOwnProperty(key)) {
              delete payload[key]
            } else {
              // 进行数据修正
              if (state.repair[key]) {
                // 确定当前值是否符合
                const ok =
                  payload[key] >=
                    (state.repair[key][0] === 'min'
                      ? 0
                      : state.repair[key][0]) &&
                  payload[key] <=
                    (state.repair[key][1] === 'max'
                      ? 999999
                      : state.repair[key][1])
                if (!ok) {
                  // 先处理左侧方式，该方式适用于实际值比预期值小的情况，但是需要同时注意，务必要比右侧值小（如果为max则无所谓）
                  if (
                    payload[key] <
                    (state.repair[key][0] === 'min' ? 0 : state.repair[key][0])
                  ) {
                    // 计算差值，进行10%的波动
                    let diff = state.repair[key][0] - payload[key]
                    diff += Math.round(diff * (Math.random() / 5))
                    if (
                      state.repair[key][1] !== 'max' &&
                      state.repair[key][1] < payload[key] + diff
                    ) {
                      // 修复超出最大值，进行控制，变为最大值
                      payload[key] = parseInt(
                        Math.random() *
                          (state.repair[key][1] - state.repair[key][0] + 1) +
                          state.repair[key][0],
                        10
                      )
                    } else {
                      payload[key] += diff
                    }
                  } else if (
                    payload[key] >
                    (state.repair[key][1] === 'max'
                      ? 999999
                      : state.repair[key][1])
                  ) {
                    // 处理右侧方式，该方式适用于实际值比预期值大的情况，但是需要注意，务必要大于左侧值（如果为min则无所谓）
                    let diff = payload[key] - state.repair[key][1]
                    diff += Math.round(diff * (Math.random() / 10))
                    if (
                      state.repair[key][0] !== 'min' &&
                      state.repair[key][0] > payload[key] - diff
                    ) {
                      // 修复超出最大值，进行控制，变为最大值
                      payload[key] = parseInt(
                        Math.random() *
                          (state.repair[key][1] - state.repair[key][0] + 1) +
                          state.repair[key][0],
                        10
                      )
                    } else {
                      payload[key] -= diff
                    }
                  }
                }
              }
              payload[key] = Math.round(payload[key])
            }
          }
        } else {
          for (let key in payload) {
            if (!state.sensor.hasOwnProperty(key)) {
              delete payload[key]
            } else {
              payload[key] = Math.round(payload[key])
            }
          }
        }
        state.sensor = Object.assign(state.sensor, payload)
      }
    },
    UPDATE_DEVICE (state, payload) {
      // 找到指定的设备，并更新
      state.devices.forEach((d) => {
        if (d.coreid === payload.coreid) {
          d.connected = payload.connected
        }
      })
    },
    UPDATE_LIGHT (state, payload) {
      state.lights.forEach((bulb) => {
        bulb.nd === payload.nd && Object.assign(bulb, payload.data)
      })
    },
    UPDATE_EXT (state, payload) {
      state.extDevices.forEach((ext) => {
        if (ext.devicetype.key === 'airswitch') {
          ext.devicetype.key === payload.type &&
            ext.nd === payload.nd &&
            ext.sid === payload.data.addr &&
            Object.assign(ext.state, payload.data)
        } else {
          ext.devicetype.key === payload.type &&
            ext.nd === payload.nd &&
            Object.assign(ext.state, payload.data)
        }
      })
      let data = Object.assign([], state.extDevices)
      // console.log(data[6])
      state.extDevices = data
    },
    UPDATE_DEVICES_BY_TYPE (state, payload) {
      if (payload.type.length) {
        // 找到指定设备的类型
        payload.type.forEach((t) => {
          if (t === 'light') {
            state.lights.forEach((bulb) => {
              let isSvae =
                !payload.include ||
                (payload.include && payload.include.includes(bulb.id))
              if (isSvae) {
                Object.assign(bulb, payload.state)
              }
            })
          } else {
            state.extDevices.forEach((ext) => {
              let isSvae =
                !payload.include ||
                (payload.include && payload.include.includes(ext.id))
              if (ext.devicetype.key === t && isSvae) {
                if (ext.devicetype.key === 'switch') {
                  if (t === 'spotlight' && ext.name.indexOf('射灯') > -1) {
                    Object.assign(ext.state, payload.state)
                  } else if (t === 'humidifier' && ext.name === '加湿器') {
                    Object.assign(ext.state, payload.state)
                  } else if (
                    t === 'switch' &&
                    ext.name.indexOf('射灯') === -1
                  ) {
                    Object.assign(ext.state, payload.state)
                  }
                } else {
                  Object.assign(ext.state, payload.state)
                  if (
                    ext.devicetype.key === 'curtain' &&
                    !payload.state.state
                  ) {
                    // 如果是窗帘，并且是关闭的话，那么状态应该是2
                    Object.assign(ext.state, { state: 2 })
                  }
                }
              }
            })
          }
        })
      }
    },
    UPDATE_DEVICE_BY_DEVICE (state, payload) {
      // 找到指定设备，并进行状态更新
      if (payload.device.devicetype) {
        // 外部设备
        state.extDevices.forEach((ext) => {
          // 特殊处理airswitch
          if (ext.devicetype.key === 'airswitch') {
            ext.deviceId === payload.device.deviceId &&
              ext.id === payload.device.id &&
              ext.sid === payload.device.sid &&
              Object.assign(ext.state, payload.state)
          } else if (
            ext.deviceId === payload.device.deviceId &&
            ext.id === payload.device.id
          ) {
            Object.assign(ext.state, payload.state)
          }
        })
        let data = Object.assign([], state.extDevices)
        state.extDevices = data
      } else {
        state.lights.forEach((bulb) => {
          if (
            bulb.nd === payload.device.nd &&
            bulb.deviceId === payload.device.deviceId
          ) {
            Object.assign(bulb, payload.state)
          }
        })
      }
    },
    ACTIVE_SCENE (state, payload) {
      state.scenes.forEach((s) => {
        if (s.id === payload) {
          s.active = true
        } else {
          s.active = false
        }
      })
    },
    /** 更新组 */
    UPDATE_GROUPS (state, payload) {
      state.groups = payload
    },
    /* 收藏和取消收藏 */
    COLLECT (state, payload) {
      if (payload.type === 'scene') {
        state.collection.scenes.push(payload.data)
        basic.setZoneConfig(
          state.zone.id,
          'collectionScenes',
          JSON.stringify(state.collection.scenes)
        )
      } else {
        state.collection.devices.push(payload.data)
        basic.setZoneConfig(
          state.zone.id,
          'collectionDevices',
          JSON.stringify(state.collection.devices)
        )
      }
      // if (state.devices[0] && state.devices[0]['version'] >= 45) {}
      // const coll = cache.getCache('collection') || {}
      // coll[state.zone.no] = state.collection
      // cache.setCache('collection', coll)
    },
    UN_COLLECT (state, payload) {
      if (payload.type === 'scene') {
        const index = state.collection.scenes
          .map((d, i) => {
            return d.id === payload.data.id ? i : -1
          })
          .filter((d) => d !== -1)
        if (index.length) {
          state.collection.scenes.splice(index[0], 1)
        }
        basic.setZoneConfig(
          state.zone.id,
          'collectionScenes',
          JSON.stringify(state.collection.scenes)
        )
      } else if (payload.data.flag === 'group') {
        const index = state.collection.devices
          .map((d, i) => {
            return d.name === payload.data.name &&
              d.type === payload.data.type &&
              JSON.stringify(d.include) === JSON.stringify(payload.data.include)
              ? i
              : -1
          })
          .filter((d) => d !== -1)
        if (index.length) {
          state.collection.devices.splice(index[0], 1)
        }
        basic.setZoneConfig(
          state.zone.id,
          'collectionDevices',
          JSON.stringify(state.collection.devices)
        )
      } else {
        const index = state.collection.devices
          .map((d, i) => {
            return d.id === payload.data.id && d.type === payload.data.type
              ? i
              : -1
          })
          .filter((d) => d !== -1)
        if (index.length) {
          state.collection.devices.splice(index[0], 1)
        }
        basic.setZoneConfig(
          state.zone.id,
          'collectionDevices',
          JSON.stringify(state.collection.devices)
        )
      }
      // const coll = cache.getCache('collection') || {}
      // coll[state.zone.no] = state.collection
      // cache.setCache('collection', coll)
    },
    UPDATE_DEVICE_NAME (state, payload) {
      if (payload.tp === 'light') {
        state.lights.forEach((l) => {
          if (l.id === payload.id) {
            l.name = payload.devicenodename
            l.alias_name = payload.alias
          }
        })
      } else {
        state.extDevices.forEach((ext) => {
          if (ext.id === payload.id) {
            ext.name = payload.name
            ext.alias_name = payload.alias
          }
        })
      }
    }
  },
  actions: {
    async updateGroups ({ commit, state }, payload) {
      let originData = JSON.parse(JSON.stringify(state.groups))
      if (!Array.isArray(payload)) {
        originData.push(payload)
      } else originData = payload
      const result = await basic.setZoneConfig(
        state.zone.id,
        'collectionGroups',
        JSON.stringify(originData)
      )
      if (result && result.code === 1) {
        commit('UPDATE_GROUPS', originData)
      }
      return result
    }
  },
  getters: {
    getRemotes (state) {
      return state.remotes
    },
    sensorState: (state) => (props) => {
      // 对环境进行处理后返回
      const sensor = {}
      for (let key in state.sensor) {
        if (props[key]) {
          // 寻找合适的范围并返回
          props[key].range &&
            props[key].range.forEach((r) => {
              if (state.sensor[key] >= r.min && state.sensor[key] <= r.max) {
                sensor[key] = {
                  key: key,
                  value: state.sensor[key],
                  text: r.text,
                  color: r.color
                }
              }
            })
          if (!sensor[key]) {
            sensor[key] = { value: 0, color: 'gray' }
          }
        }
      }
      return sensor
    }
  }
})
